export enum SharedImages {
  SingleTextAreaImg = 'single_text_area_field'
}